import { render } from "./Catalog.vue?vue&type=template&id=4476cad4"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__